import { Actions, thunk } from 'easy-peasy';
import { IStoreModel } from '~/store/types';
import api from '~/services/api';
import { IClientAllocationDetailed } from '~/services/api/clientAllocation/types';
import { IClientAllocationActions, IThunkGetOwnClientAllocation } from '../types';

const onGetOwnClientAllocation: IThunkGetOwnClientAllocation = thunk(
  async (
    { setClientAllocation }: Actions<IClientAllocationActions>,
    payload,
    { getStoreState },
  ) => {
    const store = getStoreState() as IStoreModel;

    const profile = store.user.current;

    const clientAllocation = await api.clientAllocation
      .getOwnClientAllocation({
        clientAllocationDate: payload.clientAllocationDate,
        allocationType: payload.allocationType,
      })
      .then(r => r.data);

    if (!clientAllocation) {
      return;
    }

    const normalizedAllocation = {
      id: clientAllocation.id,
      date: clientAllocation.date,
      isArchived: false,
      isOwn: true,
      isCrisis: clientAllocation.isCrisis,
      user: {
        id: profile.id,
        name: `${profile.firstName} ${profile.lastName}`,
        subRoles: profile.subRoles,
        photo: profile.photo,
        clients: clientAllocation.clients,
      },
      locationGroups: clientAllocation.locationGroups,
    };

    // normalizedAllocation nests clients/team under `user` rather than matching
    // IClientAllocationDetailed's shape exactly, same as onGetOwnClientAllocationGU
    setClientAllocation([normalizedAllocation] as unknown as IClientAllocationDetailed[]);
  },
);

export default onGetOwnClientAllocation;
